import { schema } from "normalizr";
import AttachmentRecord from "records/attachments";

const AttachmentSchema = new schema.Entity(
    "attachment",
    {},
    {
        idAttribute: "id",
    }
);

AttachmentSchema.record = AttachmentRecord;

export default AttachmentSchema;
